import $$ from '../core/dom-query.js';
import env from '../core/env';
import lists from '../core/lists';
import dom from '../core/dom';

export default class TablePopover {
  constructor(context) {
    this.context = context;

    this.ui = $$.summernote.ui;
    this.options = context.options;
    this.events = {
      'summernote.mousedown': (we, event) => {
        this.update(event.target);
      },
      'summernote.keyup summernote.scroll summernote.change': () => {
        this.update();
      },
      'summernote.disable summernote.dialog.shown': () => {
        this.hide();
      },
      'summernote.blur': (we, event) => {
        if (event.originalEvent && event.originalEvent.relatedTarget) {
          if (!this.$popover[0].contains(event.originalEvent.relatedTarget)) {
            this.hide();
          }
        } else {
          this.hide();
        }
      },
    };
  }

  shouldInitialize() {
    return !lists.isEmpty(this.options.popover.table);
  }

  initialize() {
    this.$popover = this.ui.popover({
      className: 'note-table-popover',
    }).render().appendTo(this.options.container);
    const $content = this.$popover.find('.popover-content,.note-popover-content');

    this.context.invoke('buttons.build', $content, this.options.popover.table, {
      classPrefix: 'popover',
    });

    // [workaround] Disable Firefox's default table editor
    if (env.isFF) {
      document.execCommand('enableInlineTableEditing', false, false);
    }

    this.$popover.on('mousedown', (event) => { event.preventDefault(); });
  }

  destroy() {
    this.$popover.remove();
  }

  applyPlacementStyles() {
    this.$popover.attr('data-popper-placement', 'bottom');
  }

  update(target) {
    if (this.context.isDisabled()) {
      return false;
    }

    if (dom.isImg(target) || dom.ancestor(target, dom.isImg)) {
      this.hide();
      return false;
    }

    const cell = dom.isCell(target) ? target : dom.ancestor(target, dom.isCell);
    const isCell = !!cell;

    if (isCell) {
      this.context.invoke('editor.saveTarget', cell);

      const pos = dom.posFromPlaceholder(cell);
      const containerOffset = $$(this.options.container).offset();
      pos.top -= containerOffset.top;
      pos.left -= containerOffset.left;

      this.applyPlacementStyles();

      this.$popover.css({
        display: 'block',
        left: pos.left,
        top: pos.top,
      });
    } else {
      this.hide();
    }

    return isCell;
  }

  hide() {
    this.$popover.hide();
  }
}
